module.exports = __webpack_public_path__ + "img/icon.574e56d5.png";